import { ReactComponent as Explore } from '@src/assets/images/Explore.svg';
import { ROUTE_STORE_BASE_URL } from '@src/constants/URLS.const';
import { useNavigate } from 'react-router-dom';

export function ExploreESimBanner() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(ROUTE_STORE_BASE_URL)}
      className='w-full bg-wl-primary rounded-2xl flex justify-between items-center py-4'
    >
      <div className='text-white text-left font-bold ml-8 my-4 text-base md:text-3xl lg:text-4xl'>
        <p>Explore Esimora</p>
        <p>and active your</p>
        <p>eSIM today!</p>
      </div>
      <div>
        <Explore />
      </div>
    </button>
  );
}
